(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-shipping-simulator"] && !Shopify.designMode) return;
  try {
    (function () {
  const wrap = document.querySelector('.cart-shipping__details');
  if (!wrap) return;
  const form = document.getElementById('cart-shipping-form');
  const zipInput = document.getElementById('cart-shipping-zip');
  const statusEl = document.getElementById('cart-shipping-status');
  const resultsEl = document.getElementById('cart-shipping-results');
  const btn = document.getElementById('cart-shipping-btn');
  const country = wrap.dataset.country || 'BR';

  let prefetchedProvince = null;
  let prefetchedZip = '';

  if (country === 'BR') {
    zipInput.addEventListener('input', () => {
      const digits = zipInput.value.replace(/\D/g, '').slice(0, 8);
      zipInput.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
      if (digits.length === 8 && digits !== prefetchedZip) {
        prefetchedZip = digits;
        prefetchedProvince = null;
        fetch('https://viacep.com.br/ws/' + digits + '/json/')
          .then((r) => r.json())
          .then((cep) => { if (digits === prefetchedZip) prefetchedProvince = cep.uf || ''; })
          .catch(() => { prefetchedProvince = ''; });
      }
    });
  }

  function setStatus(text, isError) {
    statusEl.textContent = text;
    statusEl.className = 'cart-shipping__status' + (isError ? ' cart-shipping__status--error' : '');
  }

  function formatPrice(priceStr) {
    const amount = parseFloat(priceStr);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'BRL'
      }).format(amount);
    } catch {
      return amount.toFixed(2);
    }
  }

  function deliveryLabel(rate) {
    const days = rate.delivery_days;
    if (days && days.length >= 2 && days[1] > 0) {
      const label = wrap.dataset.i18nDays;
      return days[0] === days[1]
        ? days[1] + ' ' + label
        : days[0] + '–' + days[1] + ' ' + label;
    }
    if (rate.delivery_date) {
      const d = new Date(rate.delivery_date + 'T12:00:00');
      const prefix = wrap.dataset.i18nArrive;
      return prefix + ' ' + d.toLocaleDateString(document.documentElement.lang || 'pt-BR', { day: '2-digit', month: '2-digit' });
    }
    return '';
  }

  function renderRates(rates) {
    resultsEl.innerHTML = '';
    if (!rates || !rates.length) {
      setStatus(wrap.dataset.i18nNoRates, false);
      return;
    }
    setStatus('', false);
    rates.forEach((rate) => {
      const isFree = parseFloat(rate.price) === 0;
      const delivery = deliveryLabel(rate);
      const li = document.createElement('li');
      li.className = 'cart-shipping__rate';
      const nameWrap = document.createElement('span');
      nameWrap.className = 'cart-shipping__rate-name';
      const nameText = document.createElement('span');
      nameText.textContent = rate.name;
      nameWrap.appendChild(nameText);
      if (delivery) {
        const daysBadge = document.createElement('small');
        daysBadge.className = 'cart-shipping__rate-days';
        daysBadge.textContent = delivery;
        nameWrap.appendChild(daysBadge);
      }
      const priceSpan = document.createElement('span');
      priceSpan.className = 'cart-shipping__rate-price' + (isFree ? ' cart-shipping__rate-price--free' : '');
      priceSpan.textContent = isFree ? wrap.dataset.i18nFree : formatPrice(rate.price);
      li.appendChild(nameWrap);
      li.appendChild(priceSpan);
      resultsEl.appendChild(li);
    });
    resultsEl.hidden = false;
  }

  function fetchRates(zip, province) {
    const params = new URLSearchParams({ 'shipping_address[zip]': zip, 'shipping_address[country]': country });
    if (province) params.set('shipping_address[province]', province);
    fetch(window.Shopify.routes.root + 'cart/shipping_rates.json?' + params)
      .then((r) => r.json())
      .then((data) => { renderRates(data.shipping_rates); })
      .catch(() => { setStatus(wrap.dataset.i18nError, true); })
      .finally(() => { btn.disabled = false; });
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const zip = zipInput.value.trim();
    const digits = zip.replace(/\D/g, '');
    if (!digits || digits.length < 4) return;

    btn.disabled = true;
    resultsEl.hidden = true;
    resultsEl.innerHTML = '';
    setStatus(wrap.dataset.i18nLoading, false);

    if (country === 'BR' && digits.length === 8) {
      if (prefetchedProvince !== null && prefetchedZip === digits) {
        fetchRates(zip, prefetchedProvince);
      } else {
        fetch('https://viacep.com.br/ws/' + digits + '/json/')
          .then((r) => r.json())
          .then((cep) => { prefetchedProvince = cep.uf || ''; fetchRates(zip, prefetchedProvince); })
          .catch(() => { fetchRates(zip, ''); });
      }
    } else {
      fetchRates(zip, '');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
